// js
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import SourcesProgressBar from './SourcesProgressBar';
import formattingUtils from '../../utils/formattingUtils';
// vcss
import '../../styles/components/sources/SourcesHeaderStats.scss';


const SourcesHeaderStats = ({
  configuredItemsCount,
  dataIndexed,
  dataRequired,
  percentIndexed,
  isPercentage,
  ciscoDataPerDay,
  nonCiscoDataPerDay,
  ciscoDataIndexed,
  nonCiscoDataIndexed
}) => {
  const classNames = classnames({
    'sources-header-stats': true,
    'sources-header-stats--full-width': !isPercentage
  });

  const containerClassNames = classnames({
    'col-md-offset-3': isPercentage,
    'col-md-6': isPercentage,
    'col-md-12': !isPercentage,
    'sources-header__progress-bar-container': true,
    'progress-bar-container': true
  });

  return (
    <div className={classNames}>
      <div className='row'>
        <div className={containerClassNames}>
          <p className='configured-items'>{formattingUtils.numberWithCommas(configuredItemsCount)} Configured items</p>
          <SourcesProgressBar
            dataIndexed={dataIndexed}
            dataRequired={dataRequired}
            totalDataRequired={dataRequired}
            progressBarHeight={50}
            percentIndexed={percentIndexed}
            isPercentage={isPercentage}
            ciscoDataPerDay={ciscoDataPerDay}
            nonCiscoDataPerDay={nonCiscoDataPerDay}
            ciscoDataIndexed={ciscoDataIndexed}
            nonCiscoDataIndexed={nonCiscoDataIndexed}
          />
        </div>
      </div>
    </div>
  );
};

SourcesHeaderStats.propTypes = {
  configuredItemsCount: PropTypes.number.isRequired,
  dataIndexed: PropTypes.number.isRequired,
  dataRequired: PropTypes.number.isRequired,
  percentIndexed: PropTypes.number.isRequired,
  isPercentage: PropTypes.bool.isRequired,
  ciscoDataPerDay: PropTypes.number,
  nonCiscoDataPerDay: PropTypes.number,
  ciscoDataIndexed: PropTypes.number,
  nonCiscoDataIndexed: PropTypes.number
};

export default SourcesHeaderStats;



// WEBPACK FOOTER //
// ./src/components/sources/SourcesHeaderStats.js